
    <!--
 * 页面-游戏-251
 * @LastEditTime: Mon Mar 31 2025 16:34:11 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_FIJ7169"  v-if="pageData.gameId ? pageData.gameId == compData.gameId : pageData.previewGameId == compData.gameId" :class="[`normal`,`u_c_FIJ7169`]" ><div id="u_c_8M78170"  :class="[`normal `,`u_c_8M78170`]" ><div id="u_c_4AAZ171"  :style="`color:${ pageData.linkTxtColor }`" :class="[`normal step`,`u_c_4AAZ171`]" >{{`${ compData.step1Txt }`}}</div><img id="u_c_9ZZD173"  :src="compData.step1Img" v-show="compData.step1Img" :class="[`normal step-img`,`u_c_9ZZD173`]" /></div><div id="u_c_BQZM174"  :class="[`normal`,`u_c_BQZM174`]" ><div id="u_c_XWNB175"  :style="`color:${ pageData.linkTxtColor }`" :class="[`normal step`,`u_c_XWNB175`]" >{{`${ langData.getStep2 }`}}</div><div id="u_c_V4BE177"  :class="[`normal`,`u_c_V4BE177`]" ><img id="u_c_0AJH178"  :src="pageData.hostInfo[pageData.curHost].step2" :class="[`normal step-img`,`u_c_0AJH178`]" /><div id="u_c_ZP6K179"  :class="[`normal`,`u_c_ZP6K179`]" >{{`${ langData.tokenKey }`}}</div></div></div><div id="u_c_YOYO181"  :class="[`normal`,`u_c_YOYO181`]" ><div id="u_c_9T1K182"  :style="`color:${ pageData.linkTxtColor }`" :class="[`normal step`,`u_c_9T1K182`]" >{{`${ langData.getStep3 }`}}</div><div id="u_c_4OJ2184"  :class="[`normal step-img`,`u_c_4OJ2184`]" ><img id="u_c_ZPAT185"  :src="`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/08/16608043509764.png`" :class="[`normal`,`u_c_ZPAT185`]" /><div id="u_c_BETI186"  :style="`color:${ pageData.hostInfo[pageData.curHost].titleColor }`" :class="[`normal`,`u_c_BETI186`]" >{{`${ langData.tokenKey }`}}</div></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"zh-CN":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"zh-TW":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"en-US":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"ja-JP":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"ko-KR":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"th-TH":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"vi-VN":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"de-DE":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"fr-FR":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"ru-RU":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"es-ES":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"pt-PT":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"it-IT":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"tr-TR":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"pl-PL":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"id-ID":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`},"ar-SA":{"gameId":251,"step1Txt":`Step1:點擊設置-用戶中心`,"step1Img":`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/09/16624350658998.jpeg`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '游戏-251';

    // 自定义setup - 开始
    ;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.default{
.u_c_8M78170.normal{
position:relative;

}
}.default{
.u_c_4AAZ171.normal{
position:relative;

}
}.default{
.u_c_9ZZD173.normal{
position:relative;

}
}.default{
.u_c_BQZM174.normal{
position:relative;

}
}.default{
.u_c_XWNB175.normal{
position:relative;

}
}.default{
.u_c_V4BE177.normal{
position:relative;

}
}.default{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.default{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.default{
.u_c_YOYO181.normal{
position:relative;

}
}.default{
.u_c_9T1K182.normal{
position:relative;

}
}.default{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.default{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.default{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.zh-CN{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.zh-CN{
.u_c_8M78170.normal{
position:relative;

}
}.zh-CN{
.u_c_4AAZ171.normal{
position:relative;

}
}.zh-CN{
.u_c_9ZZD173.normal{
position:relative;

}
}.zh-CN{
.u_c_BQZM174.normal{
position:relative;

}
}.zh-CN{
.u_c_XWNB175.normal{
position:relative;

}
}.zh-CN{
.u_c_V4BE177.normal{
position:relative;

}
}.zh-CN{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.zh-CN{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.zh-CN{
.u_c_YOYO181.normal{
position:relative;

}
}.zh-CN{
.u_c_9T1K182.normal{
position:relative;

}
}.zh-CN{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.zh-CN{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.zh-CN{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.zh-TW{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.zh-TW{
.u_c_8M78170.normal{
position:relative;

}
}.zh-TW{
.u_c_4AAZ171.normal{
position:relative;

}
}.zh-TW{
.u_c_9ZZD173.normal{
position:relative;

}
}.zh-TW{
.u_c_BQZM174.normal{
position:relative;

}
}.zh-TW{
.u_c_XWNB175.normal{
position:relative;

}
}.zh-TW{
.u_c_V4BE177.normal{
position:relative;

}
}.zh-TW{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.zh-TW{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.zh-TW{
.u_c_YOYO181.normal{
position:relative;

}
}.zh-TW{
.u_c_9T1K182.normal{
position:relative;

}
}.zh-TW{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.zh-TW{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.zh-TW{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.en-US{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.en-US{
.u_c_8M78170.normal{
position:relative;

}
}.en-US{
.u_c_4AAZ171.normal{
position:relative;

}
}.en-US{
.u_c_9ZZD173.normal{
position:relative;

}
}.en-US{
.u_c_BQZM174.normal{
position:relative;

}
}.en-US{
.u_c_XWNB175.normal{
position:relative;

}
}.en-US{
.u_c_V4BE177.normal{
position:relative;

}
}.en-US{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.en-US{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.en-US{
.u_c_YOYO181.normal{
position:relative;

}
}.en-US{
.u_c_9T1K182.normal{
position:relative;

}
}.en-US{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.en-US{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.en-US{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.ja-JP{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.ja-JP{
.u_c_8M78170.normal{
position:relative;

}
}.ja-JP{
.u_c_4AAZ171.normal{
position:relative;

}
}.ja-JP{
.u_c_9ZZD173.normal{
position:relative;

}
}.ja-JP{
.u_c_BQZM174.normal{
position:relative;

}
}.ja-JP{
.u_c_XWNB175.normal{
position:relative;

}
}.ja-JP{
.u_c_V4BE177.normal{
position:relative;

}
}.ja-JP{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.ja-JP{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.ja-JP{
.u_c_YOYO181.normal{
position:relative;

}
}.ja-JP{
.u_c_9T1K182.normal{
position:relative;

}
}.ja-JP{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.ja-JP{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.ja-JP{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.ko-KR{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.ko-KR{
.u_c_8M78170.normal{
position:relative;

}
}.ko-KR{
.u_c_4AAZ171.normal{
position:relative;

}
}.ko-KR{
.u_c_9ZZD173.normal{
position:relative;

}
}.ko-KR{
.u_c_BQZM174.normal{
position:relative;

}
}.ko-KR{
.u_c_XWNB175.normal{
position:relative;

}
}.ko-KR{
.u_c_V4BE177.normal{
position:relative;

}
}.ko-KR{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.ko-KR{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.ko-KR{
.u_c_YOYO181.normal{
position:relative;

}
}.ko-KR{
.u_c_9T1K182.normal{
position:relative;

}
}.ko-KR{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.ko-KR{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.ko-KR{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.th-TH{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.th-TH{
.u_c_8M78170.normal{
position:relative;

}
}.th-TH{
.u_c_4AAZ171.normal{
position:relative;

}
}.th-TH{
.u_c_9ZZD173.normal{
position:relative;

}
}.th-TH{
.u_c_BQZM174.normal{
position:relative;

}
}.th-TH{
.u_c_XWNB175.normal{
position:relative;

}
}.th-TH{
.u_c_V4BE177.normal{
position:relative;

}
}.th-TH{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.th-TH{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.th-TH{
.u_c_YOYO181.normal{
position:relative;

}
}.th-TH{
.u_c_9T1K182.normal{
position:relative;

}
}.th-TH{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.th-TH{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.th-TH{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.vi-VN{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.vi-VN{
.u_c_8M78170.normal{
position:relative;

}
}.vi-VN{
.u_c_4AAZ171.normal{
position:relative;

}
}.vi-VN{
.u_c_9ZZD173.normal{
position:relative;

}
}.vi-VN{
.u_c_BQZM174.normal{
position:relative;

}
}.vi-VN{
.u_c_XWNB175.normal{
position:relative;

}
}.vi-VN{
.u_c_V4BE177.normal{
position:relative;

}
}.vi-VN{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.vi-VN{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.vi-VN{
.u_c_YOYO181.normal{
position:relative;

}
}.vi-VN{
.u_c_9T1K182.normal{
position:relative;

}
}.vi-VN{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.vi-VN{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.vi-VN{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.de-DE{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.de-DE{
.u_c_8M78170.normal{
position:relative;

}
}.de-DE{
.u_c_4AAZ171.normal{
position:relative;

}
}.de-DE{
.u_c_9ZZD173.normal{
position:relative;

}
}.de-DE{
.u_c_BQZM174.normal{
position:relative;

}
}.de-DE{
.u_c_XWNB175.normal{
position:relative;

}
}.de-DE{
.u_c_V4BE177.normal{
position:relative;

}
}.de-DE{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.de-DE{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.de-DE{
.u_c_YOYO181.normal{
position:relative;

}
}.de-DE{
.u_c_9T1K182.normal{
position:relative;

}
}.de-DE{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.de-DE{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.de-DE{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.fr-FR{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.fr-FR{
.u_c_8M78170.normal{
position:relative;

}
}.fr-FR{
.u_c_4AAZ171.normal{
position:relative;

}
}.fr-FR{
.u_c_9ZZD173.normal{
position:relative;

}
}.fr-FR{
.u_c_BQZM174.normal{
position:relative;

}
}.fr-FR{
.u_c_XWNB175.normal{
position:relative;

}
}.fr-FR{
.u_c_V4BE177.normal{
position:relative;

}
}.fr-FR{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.fr-FR{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.fr-FR{
.u_c_YOYO181.normal{
position:relative;

}
}.fr-FR{
.u_c_9T1K182.normal{
position:relative;

}
}.fr-FR{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.fr-FR{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.fr-FR{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.ru-RU{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.ru-RU{
.u_c_8M78170.normal{
position:relative;

}
}.ru-RU{
.u_c_4AAZ171.normal{
position:relative;

}
}.ru-RU{
.u_c_9ZZD173.normal{
position:relative;

}
}.ru-RU{
.u_c_BQZM174.normal{
position:relative;

}
}.ru-RU{
.u_c_XWNB175.normal{
position:relative;

}
}.ru-RU{
.u_c_V4BE177.normal{
position:relative;

}
}.ru-RU{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.ru-RU{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.ru-RU{
.u_c_YOYO181.normal{
position:relative;

}
}.ru-RU{
.u_c_9T1K182.normal{
position:relative;

}
}.ru-RU{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.ru-RU{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.ru-RU{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.es-ES{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.es-ES{
.u_c_8M78170.normal{
position:relative;

}
}.es-ES{
.u_c_4AAZ171.normal{
position:relative;

}
}.es-ES{
.u_c_9ZZD173.normal{
position:relative;

}
}.es-ES{
.u_c_BQZM174.normal{
position:relative;

}
}.es-ES{
.u_c_XWNB175.normal{
position:relative;

}
}.es-ES{
.u_c_V4BE177.normal{
position:relative;

}
}.es-ES{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.es-ES{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.es-ES{
.u_c_YOYO181.normal{
position:relative;

}
}.es-ES{
.u_c_9T1K182.normal{
position:relative;

}
}.es-ES{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.es-ES{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.es-ES{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.pt-PT{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.pt-PT{
.u_c_8M78170.normal{
position:relative;

}
}.pt-PT{
.u_c_4AAZ171.normal{
position:relative;

}
}.pt-PT{
.u_c_9ZZD173.normal{
position:relative;

}
}.pt-PT{
.u_c_BQZM174.normal{
position:relative;

}
}.pt-PT{
.u_c_XWNB175.normal{
position:relative;

}
}.pt-PT{
.u_c_V4BE177.normal{
position:relative;

}
}.pt-PT{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.pt-PT{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.pt-PT{
.u_c_YOYO181.normal{
position:relative;

}
}.pt-PT{
.u_c_9T1K182.normal{
position:relative;

}
}.pt-PT{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.pt-PT{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.pt-PT{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.it-IT{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.it-IT{
.u_c_8M78170.normal{
position:relative;

}
}.it-IT{
.u_c_4AAZ171.normal{
position:relative;

}
}.it-IT{
.u_c_9ZZD173.normal{
position:relative;

}
}.it-IT{
.u_c_BQZM174.normal{
position:relative;

}
}.it-IT{
.u_c_XWNB175.normal{
position:relative;

}
}.it-IT{
.u_c_V4BE177.normal{
position:relative;

}
}.it-IT{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.it-IT{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.it-IT{
.u_c_YOYO181.normal{
position:relative;

}
}.it-IT{
.u_c_9T1K182.normal{
position:relative;

}
}.it-IT{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.it-IT{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.it-IT{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.tr-TR{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.tr-TR{
.u_c_8M78170.normal{
position:relative;

}
}.tr-TR{
.u_c_4AAZ171.normal{
position:relative;

}
}.tr-TR{
.u_c_9ZZD173.normal{
position:relative;

}
}.tr-TR{
.u_c_BQZM174.normal{
position:relative;

}
}.tr-TR{
.u_c_XWNB175.normal{
position:relative;

}
}.tr-TR{
.u_c_V4BE177.normal{
position:relative;

}
}.tr-TR{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.tr-TR{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.tr-TR{
.u_c_YOYO181.normal{
position:relative;

}
}.tr-TR{
.u_c_9T1K182.normal{
position:relative;

}
}.tr-TR{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.tr-TR{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.tr-TR{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.pl-PL{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.pl-PL{
.u_c_8M78170.normal{
position:relative;

}
}.pl-PL{
.u_c_4AAZ171.normal{
position:relative;

}
}.pl-PL{
.u_c_9ZZD173.normal{
position:relative;

}
}.pl-PL{
.u_c_BQZM174.normal{
position:relative;

}
}.pl-PL{
.u_c_XWNB175.normal{
position:relative;

}
}.pl-PL{
.u_c_V4BE177.normal{
position:relative;

}
}.pl-PL{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.pl-PL{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.pl-PL{
.u_c_YOYO181.normal{
position:relative;

}
}.pl-PL{
.u_c_9T1K182.normal{
position:relative;

}
}.pl-PL{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.pl-PL{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.pl-PL{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.id-ID{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.id-ID{
.u_c_8M78170.normal{
position:relative;

}
}.id-ID{
.u_c_4AAZ171.normal{
position:relative;

}
}.id-ID{
.u_c_9ZZD173.normal{
position:relative;

}
}.id-ID{
.u_c_BQZM174.normal{
position:relative;

}
}.id-ID{
.u_c_XWNB175.normal{
position:relative;

}
}.id-ID{
.u_c_V4BE177.normal{
position:relative;

}
}.id-ID{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.id-ID{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.id-ID{
.u_c_YOYO181.normal{
position:relative;

}
}.id-ID{
.u_c_9T1K182.normal{
position:relative;

}
}.id-ID{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.id-ID{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.id-ID{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}.ar-SA{
.u_c_FIJ7169.normal{
position:relative;

}

.u_c_FIJ7169.normal .step{
font-size:3.20vw;
color:#707070;

}

.u_c_FIJ7169.normal .step-img{
display:block;
margin:2.00vw auto 5.33vw;
max-width:100%;
border:1.33vw solid white;
box-shadow:0px 2px 5px rgba(0,0,0,0.4);

}
}.ar-SA{
.u_c_8M78170.normal{
position:relative;

}
}.ar-SA{
.u_c_4AAZ171.normal{
position:relative;

}
}.ar-SA{
.u_c_9ZZD173.normal{
position:relative;

}
}.ar-SA{
.u_c_BQZM174.normal{
position:relative;

}
}.ar-SA{
.u_c_XWNB175.normal{
position:relative;

}
}.ar-SA{
.u_c_V4BE177.normal{
position:relative;

}
}.ar-SA{
.u_c_0AJH178.normal{
position:relative;
width:100%;

}
}.ar-SA{
.u_c_ZP6K179.normal{
position:absolute;
font-size:3.47vw;
color:#444;
bottom:6.00vw;
left:12.80vw;
font-weight:bold;

}
}.ar-SA{
.u_c_YOYO181.normal{
position:relative;

}
}.ar-SA{
.u_c_9T1K182.normal{
position:relative;

}
}.ar-SA{
.u_c_4OJ2184.normal{
position:relative;
width:100%;
background-color:white;

}
}.ar-SA{
.u_c_ZPAT185.normal{
position:relative;
width:100%;

}
}.ar-SA{
.u_c_BETI186.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}
}
</style>
